import { isAxiosError as o } from "axios";
function e(r) {
  return o(r) && r.message === "Network Error";
}
export {
  e as default
};
